// Types pour le système d'événements Bus
import { Engine } from '../core/Engine';
import {
    MoveCommand,
    ScaleCommand,
    RotateCommand,
    RotateTowardCommand,
    CreateCommand,
    CloneCommand,
    MoveToCommand,
    UpdateCommand,
    DeleteCommand,
    MoveLayerCommand,
    ReorderElementCommand,
    SelectElementCommand,
    UnselectElementCommand,
    RepositionImageCommand,
    ToggleLockCommand
} from './Commands';
import { MoveCommandHandler } from './Handler/MoveCommandHandler';
import { ScaleCommandHandler } from './Handler/ScaleCommandHandler';
import { RotateCommandHandler } from './Handler/RotateCommandHandler';
import { RotateTowardCommandHandler } from './Handler/RotateTowardCommandHandler';
import { CreateCommandHandler } from './Handler/CreateCommandHandler';
import { CloneCommandHandler } from './Handler/CloneCommandHandler';
import { MoveToCommandHandler } from './Handler/MoveToCommandHandler';
import { UpdateCommandHandler } from './Handler/UpdateCommandHandler';
import { DeleteCommandHandler } from './Handler/DeleteCommandHandler';
import { MoveLayerCommandHandler } from './Handler/MoveLayerCommandHandler';
import { ReorderElementCommandHandler } from './Handler/ReorderElementCommandHandler';
import { SelectElementCommandHandler } from './Handler/SelectElementCommandHandler';
import { UnselectElementCommandHandler } from './Handler/UnselectElementCommandHandler';
import { RepositionImageCommandHandler } from './Handler/RepositionImageCommandHandler';
import { ToggleLockCommandHandler } from './Handler/ToggleLockCommandHandler';

export interface BusInstance {
    onDispatch: (() => void) | null;
    dispatch(command: any): void;
}

class BusClass implements BusInstance {
    public onDispatch: (() => void) | null = null;
    private moveHandler: MoveCommandHandler;
    private scaleHandler: ScaleCommandHandler;
    private rotateHandler: RotateCommandHandler;
    private rotateTowardHandler: RotateTowardCommandHandler;
    private createHandler: CreateCommandHandler;
    private cloneHandler: CloneCommandHandler;
    private moveToHandler: MoveToCommandHandler;
    private updateHandler: UpdateCommandHandler;
    private deleteHandler: DeleteCommandHandler;
    private moveLayerHandler: MoveLayerCommandHandler;
    private reorderElementHandler: ReorderElementCommandHandler;
    private selectElementHandler: SelectElementCommandHandler;
    private unselectElementHandler: UnselectElementCommandHandler;
    private repositionImageHandler: RepositionImageCommandHandler;
    private toggleLockHandler: ToggleLockCommandHandler;

    constructor() {
        const engine = Engine.getInstance();
        this.moveHandler = new MoveCommandHandler(engine);
        this.scaleHandler = new ScaleCommandHandler(engine);
        this.rotateHandler = new RotateCommandHandler(engine);
        this.rotateTowardHandler = new RotateTowardCommandHandler(engine);
        this.createHandler = new CreateCommandHandler(engine);
        this.cloneHandler = new CloneCommandHandler(engine);
        this.moveToHandler = new MoveToCommandHandler(engine);
        this.updateHandler = new UpdateCommandHandler(engine);
        this.deleteHandler = new DeleteCommandHandler(engine);
        this.moveLayerHandler = new MoveLayerCommandHandler(engine);
        this.reorderElementHandler = new ReorderElementCommandHandler(engine);
        this.selectElementHandler = new SelectElementCommandHandler(engine);
        this.unselectElementHandler = new UnselectElementCommandHandler(engine);
        this.repositionImageHandler = new RepositionImageCommandHandler(engine);
        this.toggleLockHandler = new ToggleLockCommandHandler(engine);
    }

    dispatch(command: any): void {
        console.log('commandanouar', command);

        // Utiliser les handlers pour traiter les commandes
        if (command instanceof CreateCommand) {
            this.createHandler.handle(command);
        } else if (command instanceof MoveCommand) {
            this.moveHandler.handle(command);
        } else if (command instanceof MoveToCommand) {
            this.moveToHandler.handle(command);
        } else if (command instanceof RotateCommand) {
            this.rotateHandler.handle(command);
        } else if (command instanceof ScaleCommand) {
            this.scaleHandler.handle(command);
        } else if (command instanceof UpdateCommand) {
            this.updateHandler.handle(command);
            // } else if (command instanceof CropCommand) {
            //     this.cropHandler.handle(command);
        } else if (command instanceof DeleteCommand) {
            this.deleteHandler.handle(command);
        } else if (command instanceof MoveLayerCommand) {
            this.moveLayerHandler.handle(command);
        } else if (command instanceof ReorderElementCommand) {
            this.reorderElementHandler.handle(command);
        } else if (command instanceof CloneCommand) {
            this.cloneHandler.handle(command);
        } else if (command instanceof SelectElementCommand) {
            this.selectElementHandler.handle(command);
        } else if (command instanceof UnselectElementCommand) {
            this.unselectElementHandler.handle(command);
        } else if (command instanceof RotateTowardCommand) {
            this.rotateTowardHandler.handle(command);
        } else if (command instanceof RepositionImageCommand) {
            this.repositionImageHandler.handle(command);
        } else if (command instanceof ToggleLockCommand) {
            this.toggleLockHandler.handle(command);
        }

        // Exécuter la commande
        if (command) {
            // Logique de dispatch des commandes
            console.log('Bus dispatch:', command);
        }

        // Appeler le callback si défini
        if (this.onDispatch) {
            this.onDispatch();
        }
    }
}

export const Bus = new BusClass();
export default Bus;
